
import { useState } from "react";
import {
  fetchOrganizerEvents,
  createEvent,
  updateEvent,
  deleteEvent as deleteEventApi,
  fetchOrganizerEventsById,
} from "../../../api/events.api";

export const useEvents = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadEvents = async (company_id) => {
    setLoading(true);
    const res = await fetchOrganizerEvents(company_id);
    setData(res.data?.data || []);
    setLoading(false);
  };

  const loadEventsById = async (company_id) => {
    const res = await fetchOrganizerEventsById(company_id);
    return res.data?.data;
  };

  const addEvent = (payload) => createEvent(payload);
  const editEvent = (id, payload) => updateEvent(id, payload);
  const deleteEvent = async (id, payload) => {
  const res = await deleteEventApi(id, payload);
  return res.data;
};

  return {
    data,
    loading,
    loadEvents,
    addEvent,
    editEvent,
    deleteEvent,
    loadEventsById
  };
};
